import gql from 'graphql-tag';

export const unityLastAccessFragment = gql`
  fragment unityLastAccessParts on UnityLastAccess {
    personContextId
    name
    profile
    creationDate
    access
    way
    place
  }
`;
